import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../config";
import { prepareHeaders } from '../configuration/tokenHandling/prepareHeaders';

export interface ResponseTags {
  items: Tag[];
}

export interface Tag {
  id: string;
  type: string;
  name: string;
  account_id: string;
}

export const tagsApi = createApi({
  reducerPath: "tagsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.backend.TAGS_SERVICE,
    prepareHeaders
  }),
  endpoints: (builder) => ({
    getTags: builder.query<ResponseTags, void>({
      query: () => "/tags",
    }),
  }),
});

// Exportando o hook gerado automaticamente
export const { useGetTagsQuery } = tagsApi;